var _a;
var Services = {
    API_URL: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : ''
};
export default Services;
